import Collapse from '@mui/material/Collapse'
import IconButton from '@mui/material/IconButton/IconButton'
import Stack from '@mui/material/Stack'
import { useState } from 'react'
import { COLORS } from 'styles/colors'
import { ReactComponent as ArrowCloseDone } from '../../assets/arrow_close_logo.svg'
import { ReactComponent as ArrowOpenDone } from '../../assets/arrow_open_logo.svg'
import { ReactComponent as LockIcon } from '../../assets/icons/lock_icon.svg'
import useAuth from '../../hook/useAuth'
import { resetInputError } from '../../store/authSlice'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import PasswordInput from '../../ui/PasswordInput'
import { OutlinedButton } from '../../ui/buttons/OutlinedButton'
import { TypographyHeader } from '../../ui/typography/TypographyHeader'
import { TypographySecondary14 } from '../../ui/typography/TypographySecondary14'
import { ProfileItem } from './utils/ProfileItem'

const SecurityBlock = () => {
	const authState = useAuth()
	const [newPassword, setNewPassword] = useState('')
	const [confirmNewPassword, setConfirmNewPassword] = useState('')
	const [open, setOpen] = useState(false)
	const [submitClicked, setSubmitClicked] = useState(false)
	const { passwordError } = useAppSelector(state => state.authReducer)
	const dispatch = useAppDispatch()
	const [serverError, setServerError] = useState<string | null>(null)

	const passwordsMatchError =
		newPassword && confirmNewPassword && newPassword === confirmNewPassword

	const handleClick = () => {
		setOpen(!open)
	}
	const handleSaveClick = async () => {
		setSubmitClicked(true)
		setServerError(null)

		try {
			await authState.setPasswordAndContinue(confirmNewPassword, newPassword)
		} catch (err: any) {
			setServerError(err.message || 'Ошибка при смене пароля')
		}
	}
	return (
		<Stack sx={{ width: '100%', minHeight: 'auto' }}>
			<ProfileItem>
				<Stack
					onClick={handleClick}
					sx={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'center',
						cursor: 'pointer',
					}}
				>
					<Stack
						sx={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							gap: '8px',
						}}
					>
						<LockIcon />
						<TypographyHeader>Безопасность</TypographyHeader>
					</Stack>
					<IconButton
						disableRipple
						disableTouchRipple
						sx={{
							padding: '0px',
							'&:hover': { backgroundColor: 'transparent' },
						}}
					>
						{open ? <ArrowOpenDone /> : <ArrowCloseDone stroke={COLORS.icon} />}
					</IconButton>
				</Stack>
				<TypographySecondary14
					sx={{
						marginTop: '16px',
						marginBottom: '16px',
					}}
				>
					Сменить пароль
				</TypographySecondary14>
				<Collapse in={open} timeout='auto' unmountOnExit>
					<Stack display='flex' gap='16px'>
						<PasswordInput
							id={'oldPassword'}
							key={'oldPassword'}
							sx={{ marginBottom: '16px' }}
							error={
								!!serverError ||
								(passwordError !== '' && passwordError !== undefined)
							}
							setConfirmNewPassword={setConfirmNewPassword}
							onClick={() => {
								dispatch(resetInputError())
								setServerError(null)
							}}
							label={'Старый пароль'}
							confirmNewPassword={confirmNewPassword}
							newPasswordSameError={serverError || undefined}
						/>
						<PasswordInput
							id={'newPassword'}
							key={'newPassword'}
							setNewPassword={setNewPassword}
							label={'Новый пароль'}
							needTooltip
							error={!!serverError || passwordsMatchError}
							newPasswordSameError={
								passwordsMatchError
									? 'Новый пароль должен отличаться от текущего'
									: serverError || undefined
							}
						/>
					</Stack>
					<Stack mt='16px'>
						<OutlinedButton
							onClick={handleSaveClick}
							disabled={
								!newPassword ||
								!confirmNewPassword ||
								newPassword.length <= 7 ||
								!/(?=.*?[A-Z])(?=.*[a-z])/.test(newPassword) ||
								!/^[A-Za-z0-9!-@#$%.^,&*()_{}[\];:"/|^]+$/.test(newPassword) ||
								passwordsMatchError
							}
							disableRipple
							type='submit'
							sx={{
								width: '100%',
								textTransform: 'none',
								marginBottom: '16px',
							}}
						>
							Сохранить изменения
						</OutlinedButton>
					</Stack>
				</Collapse>
			</ProfileItem>
		</Stack>
	)
}

export default SecurityBlock
